import { render, staticRenderFns } from "./NgoQrData.vue?vue&type=template&id=1cec74a5&scoped=true&"
import script from "./NgoQrData.vue?vue&type=script&lang=js&"
export * from "./NgoQrData.vue?vue&type=script&lang=js&"
import style0 from "./NgoQrData.vue?vue&type=style&index=0&id=1cec74a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec74a5",
  null
  
)

export default component.exports